// Shorten UUID to 22-char URL-safe base64
export const uuidToShort = (u) => {
  const hex = u.replace(/-/g, '')
  const bin = hex.match(/.{2}/g).map(b => String.fromCharCode(parseInt(b, 16))).join('')
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// Expand back to UUID
export const shortToUuid = (s) => {
  const norm = s.replace(/-/g, '+').replace(/_/g, '/')
  const padded = norm + '='.repeat((4 - (norm.length % 4)) % 4)
  const bin = atob(padded)
  const hex = [...bin].map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
